var $content = $('.js-content');

$content.find('iframe').each(function () {
    $(this).wrap('<div class="video"/>');
});

$content.find('img').not('figure img, blockquote img, .slideshowPlugin img').each(function () {
    $(this).css({height: '', width: ''});

    var
        $img = $(this),
        $parent = $img.parent();

    while ( !$parent.hasClass('js-content') ) {
        if ($parent.is('a')) {
            $img = $parent;
        } else {
            $img.unwrap();
        }

        $parent = $img.parent();
    }

    var
        caption = $.trim($(this).attr('title') || $(this).attr('alt') || '');

    if (caption.length > 0) {
        $(this).replaceWith(
            '<p><figure>' + this.outerHTML + '<figcaption>' + caption + '</figcaption></figure></p>'
        )
    } else {
        $(this).replaceWith(
            '<p>' + this.outerHTML + '</p>'
        )
    }
});

if (MOBILE) {
    var banners = $content.find('.ck-banner-panel');
    if (banners.length > 0) {
        var advertising = $('.advertising--mobile').detach();
        banners.replaceWith(advertising.prop('outerHTML'));
    }
}

if (DESKTOP) {
    var banners = $content.find('.ck-banner-panel');
    if (banners.length > 0) {
        banners.remove()
    }
}

$content.find('.slideshowPlugin').each(function(idx, slider) {
    var container = $('<div class="fotorama js-fotorama"></div>');
    $(slider).find('img').each(function() {
        var img = $('<img>').attr({ src: $(this).attr('src'), width: 780, height: 400 });
        var title = $(this).attr('title');
        if (title) img.attr('data-caption', title);
        container.append(img);
    });
    $(slider).replaceWith(container);
});
